import { render } from "./Txt.vue?vue&type=template&id=0f8bd3c9&scoped=true"
import script from "./Txt.vue?vue&type=script&lang=js"
export * from "./Txt.vue?vue&type=script&lang=js"

import "./Txt.vue?vue&type=style&index=0&id=0f8bd3c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8bd3c9"]])

export default __exports__